var map = {
	"./add.svg": "eef4",
	"./affilation_.svg": "790e",
	"./article_.svg": "de41",
	"./author_.svg": "0dca",
	"./big-anchor.svg": "52f8",
	"./check.svg": "f222",
	"./css/style.css": "6672",
	"./field_.svg": "a032",
	"./fonts/element-icons.ttf": "10ad",
	"./fonts/element-icons.woff": "0c05",
	"./icon-graph.png": "97c5",
	"./icon-map.png": "0d23",
	"./icon-table.png": "f6df",
	"./index.css": "d940",
	"./journal_.svg": "08ee",
	"./logo.png": "cf05",
	"./logo_22.png": "ee9f",
	"./logo_en.png": "3378",
	"./mapRussia.svg": "0c49",
	"./multiselect.css": "4888",
	"./organization_.svg": "749b",
	"./queries/add.svg": "16b5",
	"./queries/vers_03-02.svg": "c76b",
	"./queries/vers_03-03.svg": "76d5",
	"./queries/vers_03-04.svg": "e606",
	"./queries/добавить схему.jpg": "2d56",
	"./queries/отобразить схему.jpg": "3837",
	"./queries/поиск по подгарфу.jpg": "6ae4",
	"./queries/удалить схему.jpg": "23ae",
	"./theme.scss": "7049",
	"./иконки-19.svg": "1a92",
	"./иконки-20.svg": "8d1f",
	"./иконки-21.svg": "8f12"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";